module.exports = __webpack_public_path__ + "img/delivery-icon-12 (2).9c547a0e.png";